import React from 'react';

export const NoData: React.FC<{ message: string }> = ({ message }) => {
    return <div>{message}</div>
}